import React from "react";
import { useTranslation } from "react-i18next";
import DataTable from "components/dataTable/DataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./defaultsTableLayout.scss";

interface IDefaultsTableLayoutProps {
  /** Optional override for the tooltip id to keep it unique per usage. */
  tooltipId?: string;
  /** Width of the default value column; defaults to 40%. */
  defaultColumnWidth?: string;
  /** Additional class name forwarded to the underlying DataTable. */
  className?: string;
  /** Whether the table body should allow overflow scrolling. */
  overflow?: boolean;
  /** Whether to remove the rounded top on the DataTable. */
  noRoundedTop?: boolean;
  children: React.ReactNode;
}

export default function DefaultsTableLayout(props: IDefaultsTableLayoutProps) {
  const { t } = useTranslation();
  const {
    tooltipId = "defaults-table-tooltip",
    defaultColumnWidth = "40%",
    className = "min-h-auto",
    overflow = true,
    noRoundedTop = true,
    children,
  } = props;

  return (
    <DataTable
      noRoundedTop={noRoundedTop}
      columns={[
        { label: t("Field name") },
        {
          label: t("Default value (optional)"),
          content: (
            <div className="defaults-table-layout__label table-label flex items-center">
              <span>{t("Default value (optional)")}</span>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={tooltipId}>
                    {t("Pre-fills this value to save time. You can still edit it creating the product.")}
                  </Tooltip>
                }
              >
                <FontAwesomeIcon className="ml-1" style={{ fontSize: "16px" }} icon={faQuestionCircle} />
              </OverlayTrigger>
            </div>
          ),
          width: defaultColumnWidth,
        },
      ]}
      className={className}
      overflow={overflow}
    >
      {children}
    </DataTable>
  );
}

